"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line complexity
function compileRatingStyleString(branding) {
    const { rating = {} } = branding;
    const { borderWidth, gap, colors: { borderActive, borderInactive, fillActive, fillInactive } = {}, position } = rating;
    return `
        {
            ${borderActive ? `--rating-border-active: ${borderActive};` : ''}
            ${borderInactive ? `--rating-border-inactive: ${borderInactive};` : ''}
            ${fillActive ? `--rating-fill-active: ${fillActive};` : ''}
            ${fillInactive ? `--rating-fill-inactive: ${fillInactive};` : ''}
            ${gap ? `--rating-gap: ${gap};` : ''}
            ${isNaN(Number(borderWidth)) ? '' : `--rating-stroke-width: ${borderWidth};`}
            ${position ? `
                --rating-justify-content: ${position};
                --rating-container-flex: ${position === 'space-between' ? 1 : 0};
            ` : ''}
        }
    `;
}
exports.default = compileRatingStyleString;
